import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'

/**
 * The single place dayjs is configured.
 *
 * Plugins extend a global, so a module calling `.fromNow()` without extending
 * it first works only for as long as something else in the bundle happens to
 * have been imported earlier - and then throws the day that import order
 * changes. Everything imports dayjs from here instead.
 */
dayjs.extend(relativeTime)

export { dayjs }
